import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_END_POINT } from '../Utils/Constant';
import Navbar from '../../home/Navbar';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import baba from "../../assets/rootimg/baba.png";
import Footer from '../../home/Footer';
import cloudy from "../../assets/rootimg/cloudy.png";
import Queryform from '../Queryform';
import { useNavigate } from 'react-router';
import Loader from '../Loader';

const Panchang = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [panchangData, setPanchangData] = useState(null);
  const navigate = useNavigate();
  

  // Fetch Panchang Data
  useEffect(() => {
    const fetchPanchangData = async () => {
      try {
        const response = await axios.get(`${API_END_POINT}panchang/dailypanchang`);
        setPanchangData(response.data.response);
      } catch (error) {
        console.error("Error fetching Panchang data", error);
      }
    };

    fetchPanchangData();
  }, [selectedDate]);

  if (!panchangData) {
    return <div className='flex justify-center items-center h-screen'>
      <Loader />
    </div>;
  }

  const cards = [
    { title: "Chaughadiya", subtitle: "Muhurata", path: "/chaughadiya/panchang" },
    { title: "Hora", subtitle: "Muhurata", path: "/hora/panchang" },
    { title: "Daily", subtitle: "Panchang", path: "/daily/panchang" },
  ];


  return (
    <section className="  bg-gradient-to-r from-white to-success/40 text-gray-900 min-h-screen">
      {/* Navbar */}
      <Navbar />

      {/* Header Section */}
      <div className="text-gray-900 flex flex-col items-center mt-12">
        <h1 className="text-3xl font-serif text-secondary font-bold mb-2">PANCHANG</h1>
        <h2 className="text-base font-serif font-semibold text-secondary text-center max-w-2xl">
          Discover the Five Key Elements of Panchang that Guide Rituals, Ceremonies, and Daily Life, Ensuring Harmony with Cosmic Forces.
        </h2>
      </div>

      {/* Date Section */}
      <div className="w-[80%] sm:w-[80%] md:w-[80%] lg:w-[66%] flex items-center justify-between mt-5 bg-gradient-to-r from-success to-[#9034E9] p-4 mx-auto rounded-lg shadow-md">
        <h2 className="text-white font-sans text-2xl font-bold">
          Panchang For {selectedDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
        </h2>
      </div>

      {/* Panchang Details Section */}
      <main className="w-[80%] sm:w-[80%] md:w-[80%] lg:w-[66%] mx-auto mt-8">

        <div className="flex flex-col md:flex-row w-full">
          {/* Image Section */}
          <div className="w-full md:w-2/5">
            <img
              src={baba}
              alt="baba.png"
              className="w-full object-contain h-[250px] md:h-[350px] lg:h-[350px] rounded-lg"
            />
          </div>

          {/* Date & Weather Section */}
          <div className="w-full md:w-3/5 mt-6 md:mt-0">
            <div className="flex flex-col border-t-4 border-yellow-500 text-black bg-white p-6 rounded-lg shadow-md">
              <div className="flex flex-row justify-between bg-yellow-500 rounded-md px-3 py-2">
                <div>
                  <h2 className="text-lg font-bold">{selectedDate.toDateString()}</h2>
                  <p>Ayana: Uttarayana</p>
                  <p className="font-semibold">Shishir Ritu</p>
                </div>
                <div className="flex">
                  <img src={cloudy} alt="Weather" className="w-12 h-12 mt-2" />
                </div>
              </div>

              <div className="grid grid-cols-2 mt-4">
                <p>Sunrise <br /><strong>{panchangData.advanced_details.sun_rise}</strong></p>
                <p>Sunset <br /><strong>{panchangData.advanced_details.sun_set}</strong></p>
                <p>Moonrise <br /><strong>{panchangData.advanced_details.moon_rise}</strong></p>
                <p>Moonset <br /><strong>{panchangData.advanced_details.moon_set}</strong></p>
                <p>Hindu Sunrise <br /><strong>{panchangData.advanced_details.sun_rise}</strong></p>
                <p>Hindu Sunset <br /><strong>{panchangData.advanced_details.sun_set}</strong></p>
                <p>Sun Sign <br /><strong>{panchangData.sun_position.zodiac}</strong></p>
              </div>
            </div>
          </div>
        </div>


        {/* Panchang Elements */}
        <div className="bg-white border-t-4 border-secondary shadow-md p-6 rounded-lg mt-8">
          <h2 className="text-center font-bold bg-gradient-to-r from-success to-[#9034E9] p-1 rounded-md text-white text-lg mb-4">Panchang Elements</h2>
          <table className="w-full text-left">
            <tbody>
              <tr><td>Tithi</td><td>{panchangData.tithi.name} upto {panchangData.tithi.end}</td></tr>
              <tr><td>Nakshatra</td><td>{panchangData.nakshatra.name} upto {panchangData.nakshatra.end}</td></tr>
              <tr><td>Yog</td><td>{panchangData.yoga.name} upto {panchangData.yoga.end}</td></tr>
              <tr><td>Karan</td><td>{panchangData.karana.name} upto {panchangData.karana.end}</td></tr>
            </tbody>
          </table>
        </div>

        {/* Advanced Details */}
        <div className="bg-white shadow-md border-t-4 border-secondary p-6 rounded-lg mt-8">
          <h2 className="text-center font-bold bg-gradient-to-r from-success to-[#9034E9] p-1 rounded-md text-white text-lg mb-4">Advanced Details</h2>
          <table className="w-full text-left">
            <tbody>
              <tr><td>Sunrise</td><td>{panchangData.advanced_details.sun_rise}</td></tr>
              <tr><td>Sunset</td><td>{panchangData.advanced_details.sun_set}</td></tr>
              <tr><td>Moonrise</td><td>{panchangData.advanced_details.moon_rise}</td></tr>
              <tr><td>Moonset</td><td>{panchangData.advanced_details.moon_set}</td></tr>
              <tr><td>Next Full Moon</td><td>{panchangData.advanced_details.next_full_moon}</td></tr>
              <tr><td>Next New Moon</td><td>{panchangData.advanced_details.next_new_moon}</td></tr>
              <tr><td>Paksha</td><td>{panchangData.advanced_details.masa.paksha}</td></tr>
              <tr><td>Ritu</td><td>{panchangData.advanced_details.masa.ritu}</td></tr>
              <tr><td>Vaara</td><td>{panchangData.advanced_details.vaara}</td></tr>
              <tr><td>Moon Yogini Nivas</td><td>{panchangData.advanced_details.moon_yogini_nivas}</td></tr>
              <tr><td>Ahargana</td><td>{panchangData.advanced_details.ahargana}</td></tr>
              <tr><td>Abhijit Muhurta</td><td>{panchangData.advanced_details.abhijit_muhurta.start} to {panchangData.advanced_details.abhijit_muhurta.end}</td></tr>
            </tbody>
          </table>
        </div>

        {/* Tithi Details */}
        <div className="bg-white shadow-md border-t-4 border-secondary p-6 rounded-lg mt-8">
          <h3 className="text-center font-bold bg-gradient-to-r from-success to-[#9034E9] p-1 rounded-md text-white text-lg mb-4">Tithi Details</h3>
          <p><strong>Name:</strong> {panchangData.tithi.name}</p>
          <p><strong>Number:</strong> {panchangData.tithi.number}</p>
          <p><strong>Next Tithi:</strong> {panchangData.tithi.next_tithi}</p>
          <p><strong>Type:</strong> {panchangData.tithi.type}</p>
          <p><strong>Diety:</strong> {panchangData.tithi.diety}</p>
          <p><strong>Start:</strong> {new Date(panchangData.tithi.start).toLocaleString()}</p>
          <p><strong>End:</strong> {new Date(panchangData.tithi.end).toLocaleString()}</p>
          <p><strong>Meaning:</strong> {panchangData.tithi.meaning}</p>
          <p><strong>Special:</strong> {panchangData.tithi.special}</p>
        </div>

        {/* Nakshatra Details */}
        <div className="bg-white shadow-md border-t-4 border-secondary p-6 rounded-lg mt-8">
          <h3 className="text-center font-bold bg-gradient-to-r from-success to-[#9034E9] p-1 rounded-md text-white text-lg mb-4">Nakshatra Details</h3>
          <p><strong>Name:</strong> {panchangData.nakshatra.name}</p>
          <p><strong>Number:</strong> {panchangData.nakshatra.number}</p>
          <p><strong>Lord:</strong> {panchangData.nakshatra.lord}</p>
          <p><strong>Diety:</strong> {panchangData.nakshatra.diety}</p>
          <p><strong>Start:</strong> {new Date(panchangData.nakshatra.start).toLocaleString()}</p>
          <p><strong>End:</strong> {new Date(panchangData.nakshatra.end).toLocaleString()}</p>
          <p><strong>Meaning:</strong> {panchangData.nakshatra.meaning}</p>
          <p><strong>Special:</strong> {panchangData.nakshatra.special}</p>
          <p><strong>Summary:</strong> {panchangData.nakshatra.summary}</p>
        </div>

        {/* Karana Details */}
        <div className="bg-white shadow-md border-t-4 border-secondary p-6 rounded-lg mt-8">
          <h3 className="text-center font-bold bg-gradient-to-r from-success to-[#9034E9] p-1 rounded-md text-white text-lg mb-4">Karana Details</h3>
          <p><strong>Name:</strong> {panchangData.karana.name}</p>
          <p><strong>Number:</strong> {panchangData.karana.number}</p>
          <p><strong>Type:</strong> {panchangData.karana.type}</p>
          <p><strong>Lord:</strong> {panchangData.karana.lord}</p>
          <p><strong>Diety:</strong> {panchangData.karana.diety}</p>
          <p><strong>Start:</strong> {new Date(panchangData.karana.start).toLocaleString()}</p>
          <p><strong>End:</strong> {new Date(panchangData.karana.end).toLocaleString()}</p>
          <p><strong>Special:</strong> {panchangData.karana.special}</p>
          <p><strong>Next Karana:</strong> {panchangData.karana.next_karana}</p>
        </div>

        {/* Yoga Details */}
        <div className="bg-white shadow-md border-t-4 border-secondary p-6 rounded-lg mt-8">
          <h3 className="text-center font-bold bg-gradient-to-r from-success to-[#9034E9] p-1 rounded-md text-white text-lg mb-4">Yoga Details</h3>
          <p><strong>Name:</strong> {panchangData.yoga.name}</p>
          <p><strong>Number:</strong> {panchangData.yoga.number}</p>
          <p><strong>Start:</strong> {new Date(panchangData.yoga.start).toLocaleString()}</p>
          <p><strong>End:</strong> {new Date(panchangData.yoga.end).toLocaleString()}</p>
          <p><strong>Meaning:</strong> {panchangData.yoga.meaning}</p>
          <p><strong>Special:</strong> {panchangData.yoga.special}</p>
          <p><strong>Next Yoga:</strong> {panchangData.yoga.next_yoga}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 mt-10 gap-6">
          {cards.map((card, index) => (
            <div
              key={index}
              onClick={() => navigate(card.path)}
              className="bg-gradient-to-br from-blue-500 to-purple-400 text-white text-center font-bold text-lg sm:text-xl p-8 rounded-lg shadow-lg cursor-pointer transform transition-transform hover:scale-105"
            >
              <h2>{card.title}</h2>
              <p>{card.subtitle}</p>
            </div>
          ))}
        </div>
      </main>

      <Queryform />
      {/* Footer */}
      <Footer />
    </section>

  );
};

export default Panchang;
